export const WEBSOCKET_EVENTS = {
  UNREAD_COUNT_UPDATED: "unread_count_updated",
  OTHER_USER_TYPING: "user_typing",
  OTHER_USER_STOP_TYPING: "user_stop_typing",
  USER_TYPING: "typing",
  USER_STOP_TYPING: "stop_typing",
  SEND_MESSAGE: "send_message",
  NEW_MESSAGE: "new_message",
  MESSAGE_SENT: "message_sent",
  DELETE_MESSAGE: "delete_message",
  MESSAGE_DELETED: "message_deleted",
  MARK_READ: "mark_read",
  MESSAGES_READ: "messages_read",
  USER_ONLINE: "user_online",
  USER_OFFLINE: "user_offline",
  CONVERSATION_CREATED: "conversation_created",
};
